module.exports = __webpack_public_path__ + "img/72.282a68a3.png";